import { render, staticRenderFns } from "./FoundationProject.vue?vue&type=template&id=496849cc&scoped=true"
import script from "./FoundationProject.vue?vue&type=script&lang=js"
export * from "./FoundationProject.vue?vue&type=script&lang=js"
import style0 from "./FoundationProject.vue?vue&type=style&index=0&id=496849cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496849cc",
  null
  
)

export default component.exports